<style lang="scss" scoped>
.tags {
    display: flex;
    flex-wrap: wrap;
    margin: -4px;
    .tag {
        padding: 5px 10px;
        border-radius: 2px;
        background-color: var(--border-color);
        font-size: 80%;
        margin: 4px;
        text-align: center;
        cursor: pointer;
        transition: background 0.2s;
        user-select: none;
        display: flex;
        align-self: flex-start;
        @media (min-width: 768px) {
            &:hover {
                .close {
                    display: flex;
                }
            }
        }
        .close {
            margin: auto 0 auto 10px;
            width: 18px;
            height: 18px;
            display: none;
            position: relative;
            &:before,
            &:after {
                content: "";
                height: 1px;
                width: 10px;
                background: var(--gray);
                display: block;
                margin: auto;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
            }
            &:before {
                transform: rotate(45deg);
            }
            &:after {
                transform: rotate(-45deg);
            }
        }
        &.active {
            background-color: var(--primary-dark);
            color: #fff;
            .close {
                &:before,
                &:after {
                    background-color: #fff;
                }
            }
        }
        @media (min-width: 768px) {
            &:not(.create-tag):hover {
                background-color: var(--primary-dark);
                color: #fff;
                .close {
                    &:before,
                    &:after {
                        background-color: #fff;
                    }
                }
            }
        }
        &.add-tag {
            padding: 4px 10px;
            border: 1px solid var(--primary-dark);
            background-color: #fff;
            &.error {
                border-color: var(--danger);
            }
            @media (min-width: 768px) {
                &:hover {
                    color: var(--white);
                    background-color: var(--primary-dark);
                }
            }
        }
        &.create-tag {
            input {
                outline: none;
                box-shadow: none;
                border: none;
                background: transparent;
                padding: 0;
            }
        }
    }
}
</style>

<template>
    <div>
        <div class="tags">
            <div v-for="(complaint, key) in complaints" :key="key" class="tag" @click="medical_complaint_ids.includes(complaint.id) ? removeComplaint(complaint.id) : addComplaint(complaint.id)" :class="{ 'active' : value.includes(complaint.id) }">
                {{ $t(`${complaint.name}`) }}
                <span v-if="complaint.user_id" @click.stop="handleRemoveNewTag(complaint)" class="close"></span>
            </div>
            <div v-if="!tag_create_mode" class="tag add-tag" @click="() => { tag_create_mode = true; $nextTick(() => { $refs.tagCreate.focus() }) }">
                + {{ $t('form-elements.add-other-tags') }}
            </div>
            <div v-else class="tag create-tag">
                <input type="text" ref="tagCreate" v-model="new_tag" @keydown.enter.prevent="handleAddNewTag" @blur="handleAddNewTag">
            </div>
        </div>
    </div>
</template>

<script>

export default {
    inject: ['$validator'],
    name: 'el-medical-compaints',
    props: {
        value: {
            type: Array
        },
        user_id: {
            required: true
        }
    },
    data() {
        return {
            localvalue: null,
            medical_complaint_ids: [],
            tag_create_mode: false,
            new_tag: '',
            custom_complaints: []
        }
    },
    mounted() {
        this.$store.dispatch('general/medicalComplaints', this.user_id).then(() => {
            this.$forceUpdate()
        })
    },
    methods: {
        handleAddNewTag() {
            if (this.new_tag === '') {
                this.tag_create_mode = false
                return
            }

            this.$store.dispatch('user/createMedicalComplaints', { user_id: this.user_id, data: { name: this.new_tag } }).then((tag) => {
                this.custom_complaints.push(tag)
                this.medical_complaint_ids.push(tag.id)
                this.new_tag = ''
                this.tag_create_mode = false
                this.input()
            })
        },

        handleRemoveNewTag(tag) {
            this.$store.dispatch('user/deleteMedicalComplaints', { user_id: this.user_id, complaint_id: tag.id }).then(() => {
                const custom_complaints_index = this.custom_complaints.findIndex((t) => t.id === tag.id);
                if (custom_complaints_index > -1) {
                    this.custom_complaints.splice(custom_complaints_index, 1);
                    this.removeComplaint(tag.id)
                }
                this.medical_complaint_ids = this.medical_complaint_ids.filter(id => id !== tag.id)

                this.$store.dispatch('general/deleteMedicalComplaint', tag.id)
                this.input()
            })
        },

        input() {
            this.$emit('input', this.medical_complaint_ids)
        },
        removeComplaint(complaint_id) {
            this.medical_complaint_ids.splice(this.medical_complaint_ids.indexOf(complaint_id), 1)
            this.input()
        },
        addComplaint(complaint_id) {
            this.medical_complaint_ids.push(complaint_id)
            this.input()
        }
    },
    computed: {
        complaints() {
            return [...this.$store.getters['general/medicalComplaints'], ...this.custom_complaints]
        },
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
    },
    watch: {
        value() {
            this.medical_complaint_ids = this.value
        }
    }
}
</script>
